import React from "react";
import MainLayout from "../../Partials/MainLayout";
import FeedLayout from "../../Partials/FeedLayout";
import BusinessFeed from "./Feed";
import { Outlet } from "react-router-dom";
import CreatePost from "./CreatePost";

const Home = () => {
    return (
        <MainLayout>
            <FeedLayout>
                <BusinessFeed />
            </FeedLayout>
        </MainLayout>
    );
};

export default Home;
